import WebFont from 'webfontloader';

function loadFonts() {
  WebFont.load({
    google: {
      families: ['Roboto', 'Montserrat:400,500,700,800', 'sans-serif'],
    },
  });
}

export default loadFonts;
